import type { FC } from "react";
import { useTranslation } from "react-i18next";
import StyledDropdown from "src/components/reusable/StyledDropdown";
import StyledInput from "src/components/reusable/StyledInput";
import type { UserStatusFilter } from "../Types/UserTypes";

interface UserFiltersProps {
  searchText: string;
  statusFilter: UserStatusFilter;
  roleFilter: string[];
  onSearchChange: (_value: string) => void;
  onStatusChange: (_value: UserStatusFilter) => void;
  onRoleChange: (_value: string[]) => void;
}

const UserFilters: FC<UserFiltersProps> = ({
  searchText,
  statusFilter,
  roleFilter,
  onSearchChange,
  onStatusChange,
  onRoleChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="user-management-filters">
      <StyledInput
        className="user-input"
        placeholder={t("userManagement.searchPlaceholder")}
        value={searchText}
        onChange={event => onSearchChange(event.target.value)}
      />

      <div className="user-management-filter-group">
        <StyledDropdown
          value={statusFilter}
          className="usermanagement-dropdown"
          onChange={value => onStatusChange(value as UserStatusFilter)}
          popupClassName="custom-dropdown-menu"
          options={[
            { label: t("userManagement.filters.allUsers"), value: "all" },
            { label: t("userManagement.filters.activeUsers"), value: "active" },
            { label: t("userManagement.filters.inactiveUsers"), value: "inactive" },
          ]}
        />

        <StyledDropdown
          mode="multiple"
          showSearch={false}
          placeholder={t("userManagement.filters.selectRoles")}
          className="usermanagement-dropdown"
          value={roleFilter}
          onChange={value => onRoleChange(value as string[])}
          popupClassName="custom-dropdown-menu"
          options={[
            { label: t("userManagement.role.viewer"), value: "viewer" },
            { label: t("userManagement.role.admin"), value: "Admin" },
          ]}
        />
      </div>
    </div>
  );
};

export default UserFilters;
